function applyFilter(filter) {
  document.querySelectorAll('.showroom__col').forEach((item) => {
    const type = item.dataset.roomType;
    const hidden = filter !== 'all' && !!type && type !== filter;

    item.classList.toggle('is-hidden', hidden);
  });

  // Hiding/showing cards reflows the grid, which leaves Rellax's cached
  // parallax offsets (computed once at init) pointing at the wrong
  // elements — refresh after the browser has applied the new layout.
  requestAnimationFrame(() => window.rellax?.refresh());
}

// Keeps the active filter in the URL hash (replaceState, not pushState —
// switching filters shouldn't spam the browser history) so the current
// view can be copied and shared/reopened as a direct link.
function setHash(filter) {
  const hash = filter && filter !== 'all' ? `#${filter}` : '';
  const url = window.location.pathname + window.location.search + hash;

  window.history.replaceState(null, '', url);
  syncSeasonSwitchLinks(hash);
}

// The season switch's links are rendered server-side from the current
// request, which never sees the URL hash (fragments never reach the
// server) — so switching season while a room-type filter is active would
// otherwise silently drop back to the unfiltered "all rooms" view instead
// of staying on e.g. "cabañas". Keep those links' hash in sync with the
// active filter so switching season preserves it.
function syncSeasonSwitchLinks(hash) {
  document.querySelectorAll('.season-switch__option').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    url.hash = hash;
    link.href = url.toString();
  });
}

function activateButton(buttons, button) {
  buttons.forEach((btn) => btn.classList.remove('is-active'));
  button.classList.add('is-active');
}

function setFilters(list) {
  const buttons = [...list.querySelectorAll('.room-filters__button')];

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      activateButton(buttons, button);
      applyFilter(button.dataset.filter);
      setHash(button.dataset.filter);
    });
  });

  const initialFilter = window.location.hash.replace('#', '');
  const initialButton = initialFilter && buttons.find((btn) => btn.dataset.filter === initialFilter);

  if (initialButton) {
    activateButton(buttons, initialButton);
    applyFilter(initialFilter);
    syncSeasonSwitchLinks(window.location.hash);
  }
}

document.querySelectorAll('.js-room-filters').forEach(setFilters);
